module.exports = {
    hygl: {
        formTitle: 'Meeting Management',
        common: {
            to: 'To',
            cancel: 'Cancel',
            confirm: 'Confirm',
            confirm2: 'OK',
            close: 'Close',
            save: 'Save',
            tip: 'Tip',
            no: 'No',
            yes: 'Yes',
            operateTip: 'Operation Prompt',
            view: 'Preview',
            print: 'Print',
            commit: 'Submit',
            look: 'View',
            del: 'Delete',
            confirmTip: 'Confirm Operation',
            add: 'Add',
            edit: 'Edit',
            export: 'Export',
            noData: 'No Data Available',
            update: 'Update',
            down: 'Download',
            statistics: 'Statistics',
            topUp: 'Pin to Top',
            grounding: 'Shelf Up',
            offShelf: 'Shelf Down'
        },
        message: {
            fixTitle: 'Please fill in the file title!',
            selectPredeterminedType: 'Please select a predetermined type',
            selectMeetShape: 'Please select a meeting format',
            selectPerson: 'Please select a person or department first!',
            meetingLater: 'The meeting start time cannot be later than the current time',
            meetingBegin: 'The end time cannot be earlier than the start time',
            meetingBeginTo: 'The meeting room is open from',
            noFindH5: 'No h5 parameters detected! Please contact the administrator',
            needBeginTime: 'The start date is required!',
            needEndTime: 'The end date is required!',
            selectData: 'Please select data first!',
            needUndertaker: 'The undertaker is required',
            selectPerson2: 'Please select a person!',
            departNull: 'The department cannot be empty!',
            phoneNull: 'The phone number cannot be empty!',
            phoneInvalid: 'Invalid phone number, please enter an 11-digit mobile number!',
            reasonNeed: 'The reason for not attending is required',
            transferNeed: 'The transferee is required',
            transferReasonNeed: 'The transfer reason is required',
            hasPerson: 'This person already exists',
            saveSuccess: 'Saved successfully!',
            saveError: 'Failed to save',
            meetingCancel: 'Meeting cancellation successful',
            meetingCancelFail: 'Meeting cancellation failed',
            delSuccess: 'Deleted successfully!',
            isSelectYt: 'This topic has already been selected!',
            delFile: 'This operation will permanently delete the file. Continue?',
            selectMeetingMenu: 'Please select a meeting directory!',
            noMeetingTitle: 'No meeting topics available.',
            lationAfterCur: 'Reservation time cannot be earlier than today!',
            lationAfterCurTime: 'Please make a reservation after the current time!',
            confirmCancelLation: 'Are you sure you want to cancel the reservation?',
            meetingOpenIn: "The meeting room is open for '{day}'",
            meetingOpenIn2: "The meeting room is open for '{day}'! Please make a reservation within the opening period",
            meetingOpenIn3: 'The meeting room is open at {day}',
            meetingNumExceed: 'Cannot exceed the maximum capacity of the meeting room',
            dellCancelNoticeTitle: 'Starting from {day}/{month}/{year}, the meeting originally scheduled every {week} at {hour}:{min} to {endhour}:{endMin} has been cancelled',
            dellCancelNoticeTitle2: "{name}'s {meetName} scheduled from {time1} to {time2} has been cancelled by {name2}",
            selectFloor: 'Please select a floor to filter',
            meetingThemeNeed: 'The meeting theme is required!',
            meetingTimeNeed: 'The meeting time slot is required!',
            sSmallCur: 'The start time cannot be earlier than the current time',
            topTip: 'Recently pinned items will be displayed at the top',
            confirmTop: 'Confirm to pin to top?',
            pleaseInputReason: 'Please enter the reason for rejection',
            nohaveZw: 'There is no text to open!',
            onlyOneData: 'Only one piece of data can be selected!',
            confirmYtwsh: 'Are you sure you want to set this topic as not discussed in the meeting?',
            confirmYtysh: 'Are you sure you want to set this topic as discussed in the meeting?',
            openMeeting: 'Are you sure you want to set this meeting as already held?',
            confirmCancel: 'Are you sure to cancel?',
            noDataToExport: 'There is no data available for export!'
        },
        pageBtns: {
            selectMeeting: 'SelectTopic',
            confirmStart: 'ConfirmStart',
            saveApplay: 'ToApply',
            finishLation: 'CompleteReservation',
            hyhz: 'Receipt',
            bch: 'NotAttend',
            hyjy: 'Minutes',
            ytjy: 'IssueLog',
            ysh: 'Attend',
            wsh: 'NoAttend',
            bufa: 'Reissue',
            sjqk: 'ColSit',
            xf: 'Issued',
            cklc: 'ViewProcess',
            bftz: 'Notice',
            yzk: 'BeenHeld',
            hzxx: 'Receipt',
            ewm: 'QRCode',
            bg: 'Change',
            qx: 'Cancel',
            jytp: 'Voting',
            szck: 'setLook',
            cxzk: 'ConveneAgain',
            ckyt: 'ViewTopics'
        },
        components: {
            fields: {
                flSubject: 'Meeting Topic',
                predeterminedType: 'Reservation Type',
                meetingDate: 'Meeting Date',
                dateRange: 'Application Date Range',
                monthRange: 'Application Date Range',
                meetingTime2: 'Meeting Time:',
                meetingTimePoint: 'Meeting Time Point',
                meetingName: 'Meeting Room Name',
                meetingTypeName: 'Meeting Type',
                meetShape: 'Meeting Format',
                personName: 'Individual Participants',
                attendName: 'Dept Participants',
                workMum: 'Participants Count',
                meetHost: 'Meeting Host',
                attendLeader: 'Attending Leaders',
                flContent: 'Meeting Content',
                bfTime: 'Select Resend Range',
                startTime: 'Meeting Start Time',
                endTime: 'Meeting End Time',
                summaryName: 'Meeting Minutes Personnel',
                summaryPhone: 'Contact Number',
                openSgin: 'Whether to Open Sign-in',
                receiptEndTime: 'Receipt Time Limit',
                openExternalPerson: 'Whether there are External Personnel',
                openYt: 'Whether to Add Agenda',
                externalPersonName: 'Contact Person',
                sendInfo: 'Whether to Send Notification Immediately',
                flCreator: 'Convener',
                flCreateDept: 'Convening Dept',
                meetingAttach: 'Meeting Attachs',
                isAttend: 'Whether to Attend',
                substitutePersonnel: 'Substitute Personnel',
                notAttendingReason: 'Reason for Not Attending',
                undertaker: 'Undertaker'
            },
            addMeetingPerson: 'AddParticipant',
            meetingPlan: 'Transfer Meeting Plan',
            meetingRoom: 'Meeting Room',
            pleaseSelect: 'Please Select',
            conferenceThEmeemptyMessage: 'Please enter the meeting topic',
            bookingType: 'Reservation Type',
            ookingTypeOption1: 'One-time',
            ookingTypeOption2: 'Weekly Meeting',
            ookingTypeOption3: 'Monthly Meeting',
            bookingTypeEmptyMessage: 'Please select the meeting type',
            bookingTypeElementFormatter: 'One-time: One-time\n2: Dept Participation',
            selectDate: 'Select Date',
            startDate: 'Start Date',
            endDate: 'End Date',
            startTime: 'Start Time',
            endTime: 'End Time',
            selectTimeRange: 'Select Time Range',
            selectMonth: 'Select Month',
            meetingTime: 'Meeting Time',
            meetingTime3: 'Meeting Time: {time}',
            meetingNameEmptyMessage: 'Please enter the meeting type name',
            meetingTypeOption: 'New Employee Orientation Meeting',
            meetingTypeOption1: 'Dept Discussion Meeting',
            meetingTypeOption2: 'Dept Quarterly Meeting',
            meetingTypeOption3: 'Annual Summary Meeting',
            meetingTypeOption4: 'Employee Motivation Meeting',
            meetingTypeOption5: 'Dept Meeting',
            meetingTypeElementFormatter: 'New Employee Orientation Meeting: New Employee Orientation Meeting\nDepartment Discussion Meeting: Dept Discussion Meeting',
            meetFormEmptyMessage: 'Please select the meeting format',
            meetFormElementFormatter: '1: Individual Participation\n2: Dept Participation',
            personJoin: 'Individual Participation',
            personJoinEmptyMessage: "Please enter the participant's name",
            departJoin: 'Dept Participation',
            meetingHostEmptyMessage: 'Please enter the meeting host',
            attendingLeadershipEmptyMessage: 'Please enter the attending leaders',
            meetingContentEmptyMessage: 'Please enter the meeting content',
            attach: 'Attachment',
            fileName: 'File Name',
            fileSize: 'File Size',
            dayone: 'Monday',
            daytwo: 'Tuesday',
            daythree: 'Wednesday',
            dayfour: 'Thursday',
            dayfive: 'Friday',
            daysix: 'Saturday',
            dayseven: 'Sunday',
            day: '{day}th',
            hyglTitle: 'Resend Meeting Notification',
            selectBfRangeEmptyMessage: 'Please select the resend range',
            selectBfRangeElementFormatter: '1: Select Personnel\n2: Select Dept',
            selectPerson: 'Select Personnel',
            selectPersonEmptyMessage: 'Please select personnel',
            selectDepart: 'Select Dept',
            scanSignin: 'Scan QR Code to Sign In',
            meetingAddress: 'Meeting Location: {place}',
            meetingAddress2: 'Meeting Location',
            meetingPerson: 'Convener: {person}',
            meetingPhone2: 'Contact Number: {phone}',
            meetingPhoneEmptyMessage: "Please enter the minutes personnel's phone number",
            meeingUpdate: 'Meeting Change',
            meetingInfoTitle: 'Meeting Management Information Change',
            meetingTheme: 'Meeting Topic',
            meetingThemeEmptyMessage: 'Please enter the meeting topic',
            meetingStartTimeEmptyMessage: 'Please enter the meeting start time',
            meetingEndTimeEmptyMessage: 'Please enter the meeting end time',
            meetingPersonnelEmptyMessage: "Please enter the minutes personnel's name",
            openSginEmptyMessage: 'Please select whether to open sign-in',
            openSginElementFormatter: '1: Yes\n0: No',
            receiptEndTimemptyMessage: 'Please enter the receipt time limit',
            openExternalPersonEmptyMessage: 'Please select whether there are external personnel',
            openExternalPersonElementFormatter: '0: No\n1: Yes',
            openYtEmptyMessage: 'Please select whether to add agenda',
            externalPersonNameEmptyMessage: "Please enter the contact person's name",
            meetingAgenda: 'Meeting Agenda',
            meetingDialogTitle: 'Select Meeting Agenda',
            noAttach: 'No Attachs',
            selectYear: 'Please select the year',
            topics: 'Topics',
            reporter: 'Reporter',
            reportTime: 'Report Duration (min)',
            reportTime2: 'Report Duration',
            durationTime: 'Discussion Duration (min)',
            attendees: 'Attendees',
            attachNum: 'Number of Attachs',
            meetinger: 'Meeting Personnel',
            duties: 'Positions',
            depart: 'Dept',
            phone: 'Contact Number',
            personType: 'Personnel Type',
            insider: 'Internal Personnel',
            outsiders: 'External Personnel',
            leader: 'Leader',
            remarks: 'Remarks',
            meetingMinutes: 'Meeting Minutes',
            transferRecord: 'Transfer Record',
            transferPersonnel: 'Transferor',
            transferTime: 'Transfer Time',
            transferReason: 'Transfer Reason',
            transferReasonPlaceholder: 'Please enter the transfer reason',
            seatLayoutSettings: 'Seat Layout Settings',
            longTable: 'Long Table',
            circleTable: 'Round Table',
            uTable: 'U-Shaped Table',
            auditorium: 'Auditorium',
            delEle: 'Delete Element',
            seatSettingsWindow: 'Seat Settings Window',
            meetingRoomType: 'Meeting Room Type',
            seats: 'Seats',
            longSeats: 'Long Side Seats',
            shortSeats: 'Short Side Seats',
            personUnit: 'Person',
            personUnit2: '{num} Persons',
            podiumRowsNum: 'Number of Rows on Podium',
            podiumEveryRowsNum: 'Number of People per Row on Podium',
            podiumStageOffNum: 'Number of Rows Off Podium',
            podiumStageOffRowsNum: 'Number of People per Row Off Podium',
            printPersonSeat: 'Print Person Seat Labels',
            printMeeting: 'Print Meeting Room Layout',
            participants: 'Participants',
            participantsPlaceholder: 'Please enter participants',
            labelSize: 'Label Size',
            long: 'Length',
            width: 'Width',
            inputMeetingType: 'Please enter meeting type',
            meetingTypeOptionLabel1: 'Hospital Leadership and Party Committee Meetings',
            meetingTypeOptionLabel2: 'Meetings Held in the Name of the Hospital',
            meetingTypeOptionLabel3: 'Meetings Convened by Administrative Depts',
            meetingTypeOptionLabel4: 'International Meetings',
            meetingTypeOptionVersion1: 'Hospital Leadership Meeting',
            meetingTypeOptionVersion2: 'Hospital Party Committee Meeting',
            meetingTypeOptionVersion3: 'Attended by Main Responsible Persons of Hospital Units (Depts)',
            meetingTypeOptionVersion4: 'Attended by Responsible Persons of Hospital Units (Depts)',
            meetingTypeOptionVersion5: 'Attended by External Units and Personnel',
            meetingTypeOptionVersion6: 'Attended by Business Depts of Hospital Units',
            meetingTypeOptionVersion7: 'International Meeting',
            businessType: 'Business Type',
            time: 'Time',
            address: 'Location',
            timeAddress: 'Time: {time} Location: {address}',
            agendaArrangement: 'Agenda Arrangement: <span style="color: #1a82e3;font-size: 18px;">{num} items</span>, approximately <span style="color: #1a82e3;font-size: 18px;">{time}</span> in duration',
            hostDepartment: 'Hosting Dept',
            declarant: 'Presenter',
            csStr: 'Presenter: {person} Presentation Time: {num} minutes',
            csTime: 'Presentation Time / Minutes',
            csTime2: 'Presentation Time: {num} minutes',
            talkTime: 'Discussion Time / Minutes',
            attendDept: 'Attending Depts',
            status: 'Status',
            noMeeting: 'Not Scheduled',
            onMeeting: 'Scheduled',
            waitMeeting: 'Awaiting Scheduling',
            startReporting: 'Start Reporting',
            ytTitle: 'Agenda Materials and Attachs',
            notTimedOut: 'Not Timed Out',
            timedOut: 'Timed Out',
            formatTime: '{year}年{month}月{day}日（{weekDay}）{ampm}{formattedHour}:00',
            receipt: 'Receipt',
            substitutePersonnelPlaceholder: 'Please select a substitute',
            notAttendingReasonPlaceholder: 'Please enter the reason for not attending',
            undertakerPlaceholder: 'Please select a handler',
            change: 'Change',
            joinMeeting: 'Meeting Registration',
            position: 'Position',
            positionPlaceholder: 'Please enter position',
            orgPlaceholder: 'Please select organization staff',
            namePlaceholder: 'Please enter name',
            autoGet: 'Auto-fetch',
            departPlaceholder: 'Please enter department',
            telphone: 'Phone',
            telphonePlaceholder: 'Please enter phone number',
            meetingReceipt: 'Meeting Receipt',
            transfer: 'Transfer',
            transferer: 'Transferor',
            transfererPlaceholder: 'Please select a transferor',
            meetingDetail: 'Meeting Details',
            meetingInfo: 'Meeting Information',
            noReceived: 'Not Received',
            participation: 'Participation',
            noParticipation: 'No Participation',
            searching: 'Searching...',
            signInfo: 'Sign-in Information',
            signIn: 'Signed In',
            noSignIn: 'Not Signed In',
            signTime: 'Sign-in Time',
            meetingTj: 'Meeting Statistics',
            tjScan: 'Sign-in Statistics',
            bmtj: 'Enrollment Statistics',
            fileName2: 'File Name',
            liaisonMan: 'Liaison Officer',
            noRecord: 'No Records Yet',
            rulePhone: 'Phone number cannot be empty',
            ruleGs: 'Please enter a phone number in the correct format',
            ruleFormat: 'Please enter an 11-digit mobile phone number',
            signCode: 'Check-in QR Code',
            personSeatSetting: 'Personnel Seating Arrangement',
            isCancel: 'Cancelled',
            selectTime: 'Select Date and Time',
            order: 'Order',
            everyDay: 'Everyday',
            workDay: 'Weekdays',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            sw: 'Morning',
            xw: 'Afternoon',
            toMonth: 'This month'
        },
        hyyt: {
            meetingAgenda: 'Meeting Agenda',
            selectMeeting: 'Select Agenda',
            index: 'SN',
            hostDepartment: 'Host Dept',
            declarant: 'Presenter',
            csTime: 'Presentation Time (min)',
            csTime2: 'Presentation Time {num} minutes',
            talkTime: 'Discussion Time (min)',
            attendDept: 'Attending Depts',
            status: 'Status',
            noMeeting: 'Not in Meeting',
            onMeeting: 'In Meeting',
            waitMeeting: 'Pending Meeting',
            attach: 'Attach',
            order: 'Order',
            operate: 'Operation',
            transferLibrary: 'Transfer to Agenda Library',
            catalogTopics: 'Catalog Topics',
            move: 'Move',
            ytkTitle: 'Agenda Library',
            selectStartTime: 'Select Start Time',
            messageReminder: 'Message Reminder',
            pleaseSelect: 'Please Select',
            isReserved: 'Reserved',
            isCancel: 'Cancelled',
            isApplying: 'Applying',
            applyingPass: 'Application Approved',
            applyingNoPass: 'Application Rejected',
            meetingStartTime: 'Meeting Start Time',
            meetingEndTime: 'Meeting End Time',
            conferenceTheme: 'Conference Theme',
            meetingName: 'Meeting Room Name',
            appointedBy: 'Booked By',
            phone: 'Contact Number',
            numPeople: 'Participants Count',
            scheduled: 'Booking Status',
            week: 'Week',
            day: 'Day',
            today: 'Today',
            toWeek: 'This Week',
            site: 'Venue：',
            updateScheduled: 'Update Booking',
            cancelScheduled: 'Cancel Booking',
            cancelMeetingType: 'Cancel Meeting Type',
            cancelCur: 'Cancel Current',
            cancelAfter: 'Cancel Subsequent',
            cancellation: 'Cancel Reservation',
            lation: 'Reserved',
            meetingLation: 'Meeting Room Reservation',
            toApply: 'Apply',
            finishLation: 'Complete Reservation',
            meetingMap: 'Meeting Room Floor Plan',
            Configuration: 'Equipment Configuration:',
            alreadyBooked: 'Fully Booked',
            notAppointment: 'Unavailable for Booking',
            appointment: 'Booking',
            startTime: 'Start Time',
            endTime: 'End Time',
            meetingDialogTitle: 'Select Meeting Catalog'
        },
        portlet: {
            personUnit: '{num} people',
            conferenceTheme: 'Conference Theme:',
            conference: 'Please enter the conference theme',
            participants: 'Participants:',
            chryTip: 'Participants are required!',
            totalTime: 'Total {allTime} hours',
            participantsPlaceholder: 'Please enter participants',
            enterReservation: 'Enter Reservation',
            isQuickMeeting: 'Is this a quick booking for the meeting room?',
            quickBooking: 'Quick Booking',
            toolTip: 'Cannot book a meeting room for a past time',
            toolTip2: 'The past time slot is booked',
            toolTip3: 'The current time slot is booked',
            isNullMeeting: 'There are no available meeting rooms at this time~',
            isRowsNullMeeting: 'There are no available meeting rooms on the floor you selected~',
            selectOtherFloor: 'Please select another floor to search',
            meetingTime: 'Meeting Time Slot',
            bookNow: 'Book Now',
            hasBook: 'The meeting room has been booked',
            gwap: 'Official Arrangement',
            index: 'Serial Number',
            conferenceTitle: 'Conference Theme:',
            meetingRoom: 'Meeting Room',
            startTime: 'Start Time',
            endTime: 'End Time',
            convener: 'Convener:'
        },
        voteManage: {
            resolutionVoting: 'Resolution Voting',
            look: 'View',
            statistics: 'Statistics',
            topUp: 'Top',
            grounding: 'Shelve',
            offShelf: 'Unshelve',
            addTopic: 'Add Topic',
            submitwj: 'Submit Questionnaire',
            notSelevtTopit: 'There are topics not selected!',
            voteed: 'You have completed the vote',
            votingResults: 'Voting Results',
            votinger: 'Voter',
            promoter: 'Initiator: {voteName}',
            deadline: 'Deadline: {endTime}',
            voto: '{num} votes',
            votoTitle: 'Voting Theme: {voteTheme}',
            votoScan: 'Scan QR code to vote',
            votoScan2: 'Voting QR Code',
            total: 'Total',
            voting: 'Voting',
            Radio: 'Single Choice',
            multipleChoice: 'Multiple Choice',
            item: 'Option {num}',
            specifyGroup: 'Specify Group',
            specifyGroupPlaceholder: 'Please select the specified group',
            specifyDepart: 'Specify Dept',
            specifyDepartPlaceholder: 'Please select the specified department',
            specifyPerson: 'Specify Person',
            specifyPersonPlaceholder: 'Please select the specified person',
            isVoto: 'Voted',
            noVoto: 'Not voted',
            votoTotal: 'Voting Statistics',
            join: 'Participate',
            abstained: 'Abstained',
            votoDetail: 'Voting Details',
            questionnaireCode: 'QRCode',
            topic: 'Topic',
            votoTopic: 'Voting Topic',
            votoTopicPlaceholder: 'Voting Topic',
            votoType: 'Voting Type',
            votoTypePlaceholder: 'Voting Type',
            votingOptions: 'Voting Options',
            optionTitle: 'Option Title',
            pic: 'Image',
            picPlaceholder: 'Please select an image',
            addItem: 'Add Option'
        },
        menuItem: {
            meetingHome: 'Meeting Home',
            meetingSchedule: 'Meeting Schedule',
            myMeeting: 'My Meetings',
            pendingReceipt: 'Pending Receipts',
            waitingAttend: 'Waiting to Attend',
            alreadyAttended: 'Already Attended',
            noParticipation: 'Not Participating',
            alreadyCancel: 'Already Cancelled',
            meeetingConference: 'Meeting Registration',
            meetingReservation: 'MeetingRoom Reservation',
            initiateReservation: 'Initiate Reservation',
            scheduledRecords: 'Reservation Records',
            bookingApplication: 'Reservation Application',
            meetingNotice: 'Meeting Notice',
            meetingAgenda: 'Meeting Agenda',
            myAgenda: 'My Agenda',
            meetingMinutes: 'Meeting Minutes',
            meetingVoting: 'Meeting Voting',
            topicCollection: 'Topic Collection',
            topicReporting: 'Topic Reporting',
            ytkTitle: 'Topic Library',
            notGenerated: 'Not Generated',
            generated: 'Generated',
            conferenceDirectory: 'Conference Directory',
            tobeHeld: 'To Be Held',
            inProgress: 'In Progress',
            convened: 'Convened',
            resolutionVoting: 'Resolution Voting',
            notStarted: 'Not Started',
            oning: 'Ongoing',
            meetingManagement: 'Meeting Management',
            todayMeeting: "Today's Meetings",
            waitingMeeting: 'Waiting Meetings',
            historicalConference: 'Historical Conferences',
            issueLog: 'Issue Log',
            resourceManagement: 'Resource Management',
            conferenceRoomManagement: 'ConferenceRoom Management',
            meetingType: 'Meeting Type',
            siteManagement: 'Site Management',
            equipmentManagement: 'Equipment Management',
            huifuManagement: 'Meeting Services Management',
            myStated: 'My Statements',
            isVoto: 'Voted',
            noVoto: 'Not Voted',

            // General
            all: 'All',
            myCreate: 'My Organized',
            mycreated: 'My Created',
            todo: 'To Do',
            done: 'Done',
            processingProgress: 'Processing',
            myDraft: 'My Drafts',
            draft: 'Draft',
            Ended: 'Ended',
            myHandled: 'My Handled',
            allApplications: 'All Applications',
            noSelect: 'Not Selected',
            isSelect: 'Selected'
        },
        voteResult: {
            formTitle: 'Vote Result Form',
            fields: {
                index: 'SN',
                depart: 'Dept',
                votinger: 'Voter',
                phone: 'Contact',
                votingResults: 'Voting Results'
            }
        },

        jyap: {
            formTitle: 'Meeting Minutes Application',
            fields: {
                meetingName: 'Meeting Topic',
                startTime: 'Meeting Start Time',
                flCreator: 'Creator',
                endTime: 'Meeting End Time',
                flCreateDept: 'Creating Dept',
                flCreatorPhone: 'Contact Phone',
                flContent: 'Meeting Decisions',
                meetPlace: 'Meeting Location',
                flSubject: 'Meeting Minutes Title',
                flCreateDate: 'Creation Date',
                attendName: 'Attendees'
            }
        },
        meetingRoom: {
            formTitle: 'Meeting Room Management',
            fields: {
                meetImgurl: 'Meeting Room Image',
                approve: 'Approval Required',
                meetName: 'Meeting Room Name',
                site: 'Meeting Room Site',
                deviceProperties: 'Equipment Configuration',
                servePersonName: 'Meeting Room Service Personnel',
                remark: 'Remark',
                layoutName: 'Seating Arrangement',
                serviceProperties: 'Service Configuration',
                userIdName: 'Meeting Room Administrator',
                meetId: 'Meeting Room ID',
                status: 'Status',
                openTime: 'Opening Time',
                openDate: 'Opening Cycle'
            },
            options: {
                approve: {
                    1: 'yes',
                    0: 'no'
                },

                status: {
                    0: 'Disable',
                    1: 'Enable'
                }
                // 动态的
                // serviceProperties: {
                //     点餐: 'order',
                //     测试: 'test',
                //     水: 'water'
                // },
                // deviceProperties: {
                //     话筒: 'microphone',
                //     电脑: 'computer',
                //     一体屏幕: 'Integrated screen'
                // }
            }
        },
        ytsj: {
            formTitle: 'Agenda Collection',
            fields: {
                deptName: 'Collection Dept',
                content: 'Collection Task',
                remark: 'Remarks',
                reportEndDate: 'Collection Deadline'
            }
        },
        hyap: {
            formTitle: 'Meeting Notice',
            fields: {
                userPost: 'Position',
                openYt: 'Add Agenda',
                summaryPhone: 'Contact Phone',
                flCreatorPhone: "Applicant's Phone",
                meetPlace: 'Meeting Venue',
                workMum: 'Participants Count',
                meetHost: 'Meeting Host',
                startTime: 'Meeting Start Time',
                openExternalPerson: 'External Participants',
                mainDept: 'Sponsoring Dept',
                receiptEndTime: 'Reply Deadline',
                flSubject: 'Meeting Agenda',
                attendName: 'Observers',
                flContent: 'Meeting Content',
                meetingTypeName: 'Meeting Type',
                meetShape: 'Meeting Format',
                endTime: 'Meeting End Time',
                openSgin: 'Enable Sign-in',
                flCreator: 'Applicant',
                externalPersonName: 'Contact Person',
                summaryName: 'Minutes Recorder',
                flCreateDate: 'Application Date',
                flCreateDept: 'Application Dept',
                sAttendName: 'Observers per Agenda',
                attendLeader: 'School Executive Council Member'
            },
            options: {
                reissue: {
                    1: 'Individual', //个人
                    2: 'Department' //部门
                },
                meetShape: {
                    1: 'Individual Participants',
                    2: 'Dept Participants'
                },
                openSgin: {
                    1: 'yes',
                    0: 'no'
                },
                openExternalPerson: {
                    1: 'yes',
                    0: 'no'
                },
                openYt: {
                    1: 'yes',
                    0: 'no'
                }
            }
        },
        hyapYtInfo: {
            formTitle: 'Meeting Notice Agenda Details',
            fields: {
                mainDept: 'Sponsoring Dept',
                createDate: 'Creation Date',
                reportTime: 'Presentation Time (min)',
                creator: 'Registrar',
                isAttendDept: 'Fixed Observer Depts',
                subject: 'Meeting Agenda',
                talkTime: 'Discussion Time (min)',
                isPpt: 'PPT Presentation',
                isWritten: 'Written Notification',
                attendDept: 'Observer Depts',
                remark: 'Remarks',
                reportPersonName: 'Presenter',
                subjectTypeName: 'Meeting Type',
                attendStoolName: 'Observers'
            },
            options: {
                isPpt: {
                    0: 'No',
                    1: 'Yes'
                },
                isAttendDept: {
                    0: 'No',
                    1: 'Yes'
                },
                isWritten: {
                    0: 'No',
                    1: 'Yes'
                }
            }
        },
        meetingEpment: {
            formTitle: 'Equipment Management',
            fields: {
                epmentNo: 'Sorting Number',
                epmentName: 'Meeting Room Equipment'
            }
        },
        meeting: {
            formTitle: 'Meeting Room Reservation Form ',
            fields: {
                agentPhone: "Agent's Phone",
                agentUser: 'Agent',
                meetSubjedt: 'Meeting Subject',
                meetName: 'Meeting Room',
                serviceProperties: 'Service Configuration',
                deviceProperties: 'Equipment Configuration',
                week: 'Reservation Period',
                weeks: 'opening period',
                applayName: "Applicant's Name",
                attendUserName: 'Participants',
                numPeople: 'Participants Count',
                preordainType: 'Reservation Type',
                meetDetails: 'Meeting Content',
                meetTime: 'Meeting Time',
                departmentUser: 'Using Dept',
                endTime: 'End Time',
                beginTime: 'Start Time',
                // remindType: 'Reminder method'
                saveApplay: 'toSaveApplay',
                meetInfo: 'MeetingRoom Information',
                remind: 'Reminder Method'
            },
            options: {
                preordainType: {
                    0: 'One-time',
                    1: 'periodicity'
                },
                status: {
                    0: 'Cancelled', //已取消
                    1: 'Reserved', //已预订
                    2: 'Pending Approval', //申请中
                    3: 'Approved', //申请通过
                    4: 'Rejected', //申请不通过
                    5: 'Draft' //草稿
                }
            }
        },
        vote: {
            formTitle: 'Vote Resolution > Vote Theme',
            fields: {
                startTime: 'Start Time',
                voteTheme: 'Vote Theme',
                sponsor: 'Sponsor',
                endTime: 'End Time',
                voteType: 'Voting Method',
                voteRange: 'Voting Range'
            },
            options: {
                voteType: {
                    1: 'Secret ballot',
                    2: 'noSecret ballot'
                },
                voteRange: {
                    1: 'All',
                    2: 'Dept',
                    4: 'Assigner'
                }
            }
        },
        meetDirectory: {
            formTitle: 'Meeting Directory',
            fields: {
                createDate: 'Creation Date',
                subjectTypeName: 'Meeting Type Name',
                creator: 'Creator',
                subject: 'Meeting Directory'
            }
        },
        meetingServe: {
            formTitle: 'Meeting Room Services',
            fields: {
                imageName: 'Service Photo',
                epmentNo: 'Sorting Number',
                epmentName: 'Service Name'
            }
        },
        ytRecord: {
            formTitle: 'Topic Library',
            fields: {
                resolution: 'Proposed Resolution for Review'
            },
            options: {
                isPpt: {
                    1: 'yes',
                    0: 'no'
                },
                isAttendDept: {
                    1: 'yes',
                    0: 'no'
                },
                isWritten: {
                    1: 'yes',
                    0: 'no'
                }
            }
        },
        plan: {
            formTitle: 'Meeting Plan',
            fields: {
                flCreateDate: 'Creation Date',
                attendNum: 'Number of Attendees',
                meetPlace: 'Meeting Location',
                endTime: 'Meeting End Time',
                flCreateDept: 'Dept',
                meetContent: 'Meeting Content',
                flCreator: 'Creator',
                startTime: 'Meeting Start Time',
                meetTheme: 'Meeting Theme'
            }
        },
        cysy: {
            formTitle: 'Meeting Management > Circulation Review',
            fields: {
                flDealDate: 'Handling Deadline',
                flCreatorPhone: 'Contact Phone',
                flCreator: 'Applicant',
                flCreateDate: 'Application Date',
                meetingTypeName: 'Meeting Type',
                ytName: 'Meeting Topic',
                resolution: 'Proposed Resolution for Review',
                flJbr: 'Handler',
                flSubject: 'Meeting Theme',
                mainDept: 'Hosting Dept',
                flCreateDept: 'Applying Dept'
            }
        },
        deptytRecord: {
            formTitle: 'Dept Topic Library',
            fields: {
                isAttendDept: 'Fixed Attend Dept',
                talkTime: 'Discussion Time (min)',
                attendDept: 'Attending Depts',
                isPpt: 'PPT Presentation Required',
                mainDept: 'Hosting Dept',
                remark: 'Remarks',
                attendStoolName: 'Attending Personnel',
                createDate: 'Application Date',
                reportPersonName: 'Presenter',
                creator: 'Applicant',
                isWritten: 'Written Notification',
                subject: 'Meeting Topic',
                reportTime: 'Report Time (min)',
                resolution: 'Proposed Resolution for Review',
                subjectTypeName: 'Meeting Type'
            }
        },
        roomApply: {
            formTitle: 'Meeting Room Application Form ',
            fields: {
                flContent: 'Meeting Content',
                remark: 'Remarks',
                flSubject: 'Meeting Theme',
                agentUser: 'Handler',
                agentPhone: "Handler's Phone",
                preordainType: 'Reservation Type',
                flCreateDept: 'Applying Dept',
                meetName: 'MeetingRoom Name',
                flCreatorPhone: 'Contact Phone',
                flCreateDate: 'Application Date',
                flCreator: 'Applicant',
                meetPlace: 'MeetingRoom Location',
                hysSelect: 'Meeting reservation selection:',
                meetTime: 'Meeting Time',
                weekday: 'Meeting Date',
                endTime: 'Meeting Time Point',
                yyDataRange: 'Application Date Range',
                checkListss1: 'Reservation Cycle',
                remind: 'Reminder Method',
                meetInfo: 'MeetingRoom Information',
                numPeople: 'MeetingRoom Capacity',
                fwpz: 'Service Configuration',
                hyssb: 'MeetingRoom Equipment',
                weekProperties: 'Opening Cycle'
            },
            options: {
                preordainType: {
                    0: 'One-time',
                    1: 'periodicity'
                }
            }
        },
        site: {
            formTitle: 'Venue Management',
            fields: {
                orderNo: 'Sorting Number',
                name: 'Venue Name',
                status: 'Status'
            },
            options: {
                status: {
                    0: 'Disable',
                    1: 'Enable'
                }
            }
        },
        ytap: {
            formTitle: 'Meeting Topic',
            fields: {
                attendStoolName: 'Attending Personnel',
                reportTime: 'Report Duration (min)',
                isAttendDept: 'Fixed Attend Dept',
                flCreatorPhone: 'Contact Phone',
                resolution: 'Proposed Resolution for Review',
                isPpt: 'PPT Presentation Required',
                ytsjName: 'Associated Topic Collection Task',
                remark: 'Remarks',
                mainDept: 'Hosting Dept',
                flCreateDept: 'Applying Dept',
                talkTime: 'Discussion Duration (Min)',
                isWritten: 'Written Notification',
                endTime: 'Collection End Time',
                reportPersonName: 'Reporter',
                flSubjectType: 'Meeting Type',
                flCreateDate: 'Application Date',
                flSubject: 'Meeting Topic',
                attendDept: 'Attending Depts',
                flCreator: 'Applicant'
            },
            options: {
                isPpt: {
                    1: 'yes',
                    0: 'no'
                },
                isAttendDept: {
                    1: 'yes',
                    0: 'no'
                },
                isWritten: {
                    1: 'yes',
                    0: 'no'
                }
            }
        },
        type: {
            formTitle: 'Meeting Type',
            fields: {
                orderNo: 'Sorting',
                typeName: 'Meeting Type',
                status: 'Status'
            },

            options: {
                status: {
                    0: 'Disable',
                    1: 'Enable'
                }
            }
        },
        meetPeople: {
            // Participant list for the meeting
            formTitle: 'Participant List for the Meeting',
            fields: {
                remark: 'Remarks',
                userName: 'Name',
                userPost: 'Position',
                userDept: 'Department',
                personType: 'Person Type',
                phone: 'Phone',
                remark2: 'Reject Reason',
                signTime: 'Attachments'
            }
        },
        ytjy: {
            // Meeting Minutes
            formTitle: 'Meeting Minutes',
            fields: {
                flCreator: 'Applicant',
                flCreateDept: 'Application Dept',
                flContent: 'Meeting Minutes Content',
                startTime: 'Meeting Start Time',
                endTime: 'Meeting End Time',
                flSubject: 'Meeting Topic',
                flCreateDate: 'Application Date',
                flCreatorPhone: 'Contact Number',
                hyapYt: 'Meeting Minutes Title'
            }
        }
    }
}
